module.exports = __webpack_public_path__ + "static/img/office-slide-2.cc773db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/office-slide-2.png
// module id = 3ZEh
// module chunks = 0